import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
export interface TabListModel { 
  key: string;
  value: string
}

export interface StatusListModel {
  id: string;
  label: string
}

@Component({
  selector: 'ipm-filter-search-section',
  templateUrl: './filter-search-section.component.html',
  styleUrls: ['./filter-search-section.component.scss']
})
export class FilterSearchSectionComponent implements OnInit {
  @Input({required: false}) userType: string = "";
  @Input({required: false}) heading: string = "";
  @Input({required: false}) currentSelectedTab: string = "";
  @Input({required: false}) tabList: Array<TabListModel> = [];
  @Input({required: false}) statusListData: Array<StatusListModel> = [];
  @Input({required: false}) selectedStatusData: StatusListModel | null = null;
  @Input({required: false}) isShowTab: boolean = false;
  @Input({required: false}) isShowingSorts: boolean = true;
  @Input({required: false}) isShowingSearch: boolean = true;
  @Input({required: false}) serachText: string = "Beat";
  @Output() tabChangeEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() statusChangeEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() searchChangeEvent: EventEmitter<any> = new EventEmitter<any>();
  constructor() {}

  ngOnInit(): void {
    if (this.isShowTab) {
      this.isShowTab = this.userType === 'buyer' ? false : this.tabList && this.tabList.length > 0 ? true : false;
    } 
  }

  /**
   * Tab Change Event Trigger Function
   * @param $event
   */
  handleTabChangeEvent($event: any) {
    this.tabChangeEvent.emit($event);
  }

  /**
   * Status Change Event Trigger Function
   * @param $event
   */
  handleStatusChange($event: any) {
    this.statusChangeEvent.emit($event);
  }

  /**
   * Search Event Trigger Function
   * @param $event
   */
  onChangeSearchInput($event: Event) {
    const value = ($event?.target as HTMLInputElement)?.value;
    this.searchChangeEvent.emit(value);
  }
}
